<table class="table">
  <thead>
    <tr>
      <!-- <th scope="col"></th> -->
      <th scope="col" style="cursor: pointer;" sortable="lane" (sort)="onSort($event)">#</th>
      <th scope="col" style="cursor: pointer;" sortable="name" (sort)="onSort($event)">Name</th>
      <th scope="col">Time</th>
      <th scope="col" style="width: 15%;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let entry of test">
      <!-- <td>
        <div *ngIf="!entry.start && !entry.finish && (signedIn && entry.referees?.includes((currentUser)?.uid) || (signedIn && entry.owner && entry?.owner==(currentUser)?.uid))">
          <button (click)="markStart(entry.id)" class="btn btn-success">Start</button>
        </div>
      </td> -->
      <th scope="row">{{ entry.lane }}</th>
      <td>{{ entry.name }}</td>
      <td>{{ entry.time() }}</td>
      <td>
        <div *ngIf="entry.start && !entry.finish && (signedIn && entry.referees?.includes((currentUser)?.uid) || (signedIn && entry.owner && entry?.owner==(currentUser)?.uid))">
          <button (click)="markFinished(entry.id)" class="btn btn-success">Finish</button>
        </div>
      </td>
    </tr>
  </tbody>
</table>